export const lineLayer = {
  id: "geofence-line",
  type: "line",
  paint: {
    "line-color": ["get", "color"],
    "line-width":2 
  },
  filter: ["==", "$type", "LineString"]
};

export const fillLayer = {
  id: "geofence-fill",
  type: "fill",
  paint: {
    "fill-color": ["get", "color"],
    "fill-opacity": 0.3
  },
  filter: ["==", "$type", "Polygon"]
};

export const circleLayer = {
  id: "geofence-circle",
  type: "circle",
  paint: {
    "circle-radius": [
      "interpolate",
      ["linear"],
      ["zoom"],
      5, ["*", ["get", "radius"], 0.01], // ズーム5の時に縮小
      10, ["*", ["get", "radius"], 0.02], // ズーム10の時に適度にスケール
      15, ["*", ["get", "radius"], 0.05], // ズーム15の時に拡大
      20, ["*", ["get", "radius"], 0.1]  // ズーム20の時に最大サイズ
    ],
    "circle-color": ["get", "color"],
    "circle-opacity": 0.4, // 少し透明にする
    "circle-stroke-width": 2,
    "circle-stroke-color": ["get", "color"]
  },
  filter: [
            "all",
            ["==", "$type", "Point"],
            ["has", "radius"],
          ] 
};


export const symbolLayer = {
  id: "symbol-layer",
  type: "symbol",
  layout: {
    'icon-image': 'location-icon',  // カスタムアイコンを指定
    //'icon-size': 0.1,               // アイコンサイズの調整
    "icon-size": 0.25, // アイコンサイズを30pxに調整
    'icon-anchor': 'bottom',        // アイコンのアンカー位置
    "icon-image": ["coalesce", ["get", "icon-image-url"], "location-icon"], // デフォルトのピンを使用
    'text-field': ['get', 'name'],
    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
    'text-radial-offset': 0.5,
    'text-justify': 'auto',
    'symbol-sort-key': ['get', 'priority'], // 優先度を指定
  },
  paint: {
    'text-color': ["coalesce", ["get", "color"], "#FFFFFF"],
  },
  filter: ["==", "$type", "Point"]
};
